import { getApi } from '.';
import QApi from './base/qapi';
import { createRequestParamsTransformer } from './base/transformers';

export const setupApiAccount = (data: {
  accountId: number;
  accountUid: string;
  masterAccountId: number | null;
  masterAccountUid: string | null;
}) => {
  const api = getApi();

  api.setAccountId(data.accountId);
  api.setAccountUid(data.accountUid);

  // Replace account identifiers on selected endpoints with masters' if it's a slave account
  if (data.masterAccountId != null && data.masterAccountUid != null) {
    injectSlaveRequestParamsTransformer(
      data.masterAccountId,
      data.masterAccountUid,
      getSwappableEndpoints(),
      api
    );
  }
};

export const getSwappableEndpoints = () => [
  'device',
  'devices',
  'deviceVersion',
  'deviceRules',
  'profiles',
  'deviceUserEvents',
  'safeNetworksSettings',
  'safeNetworksEvent',
  'uploadsPresignedUrls',
];

export const injectSlaveRequestParamsTransformer = (
  masterAccountId: number,
  masterAccountUid: string,
  endpoints: string[],
  api: QApi
) => {
  // When more than one transformer is necessary, execution order may be important!!
  api.addRequestTransformer(
    createRequestParamsTransformer({
      endpoints,
      swappableParams: {
        accountId: masterAccountId,
        accountUid: masterAccountUid,
      },
    })
  );
};
